import { strategyToOptions } from '@/common/utils/strategyToOptions'

export const driverLicenseRequirementsForConsumptions = {
  none: 'Nunca',
  validate_expiration_date_if_present: 'Validar data de expiração caso CNH esteja presente',
  validate_presence_and_future_expiration_date: 'Validar presença da CNH e a data de expiração',
}

export const driverLicenseRequirementsForConsumptionsOptions = strategyToOptions(
  driverLicenseRequirementsForConsumptions,
)
